import { Slide } from "@jelly/lesson";
import { task as task03 } from "../../../../../task/course-05/lesson-11/task-03";

const task: Slide = {
  titleHtml: `If one manages to strengthen the lateral early reflections arriving to the listener seats<br>through careful acoustic and architectural design, what consequences will that have?`,
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
